import React from "react";
import { staticFastlyAppUrl } from "../../../constants/url-constants";

const SchemaHome = () =>
    (<script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify(
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Cars24 Services Pvt. Ltd.",
                "url": "https://www.cars24.com/",
                "logo": `${staticFastlyAppUrl()}/cars24/seo/static/1_20230830_1693395013.png`,
                "foundingDate": "2015",
                "founders": [
                    {
                        "@type": "Person",
                        "name": "Vikram Chopra"
                    },
                    {
                        "@type": "Person",
                        "name": "Mehul Agrawal"
                    }],
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "10th Floor, Tower B, Unitech Cyber Park",
                    "addressLocality": "Sector 39",
                    "addressRegion": "HR",
                    "postalCode": "122003",
                    "addressCountry": "India"
                },
                "contactPoint": {
                    "@type": "ContactPoint",
                    "contactType": "customer support",
                    "telephone": "+1800 258 5656",
                    "email": "care@cars24.com"
                },
                "sameAs": [
                    "https://www.facebook.com/cars24india/",
                    "https://twitter.com/cars24india/",
                    "https://www.instagram.com/cars24india/",
                    "https://www.youtube.com/channel/UCV-CPspQhwTsaiftR4JvT0w/",
                    "https://in.linkedin.com/company/cars24/"
                ]
            }
        )
    }} />);

export default SchemaHome;
